import React from "react";
import {
  Box,
  Typography,
  Container,
  ButtonBase,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  LinearProgress,
} from "@mui/material";

import RightArrowIcon from "../icons/RightArrowIcon";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const TabButton = ({ children, sx, disabled, onClick, loading }) => {
  return (
    <ButtonBase
      onClick={onClick}
      style={{
        backgroundColor: "#1F222A",
        borderRadius: "12px",
        minHeight: "55px",
        border: "none",
        cursor: "pointer",
        padding: "10px 20px",
        width: "100%",
        height: "65px",
        maxWidth: "400px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        opacity: disabled ? 0.5 : 1,
        ...sx,
      }}
      disabled={disabled}
    >
      {!loading && (
        <Typography
          style={{
            fontWeight: "500",
            fontSize: "18px",
            color: "white",
            textAlign: "left",
          }}
        >
          {children}
        </Typography>
      )}
      <ArrowForwardIcon fontSize="large" style={{ color: "#FF9700" }}></ArrowForwardIcon>
      {/*loading && (
        <LinearProgress
          sx={{
            width: "100%",
            backgroundColor: "#181A20", // Color de fondo de la barra vacía
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#FF9700", // Color de la barra de progreso
            },
          }}
        />
      )*/}
      {loading && (
        <CircularProgress
          sx={{
            color: "white",
            height: "100%", // Ajusta la altura al 100% del botón
            width: "100%", // Ajusta el ancho al 100% del botón
          }}
          size={26}
        />
      )}
    </ButtonBase>
  );
};

export default TabButton;
